<template>
  <section class="admin-content" id="verify-org-page">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-shield" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">{{ organization.name || 'Organization Verification' }}</h4>
                <div class="d-flex align-items-center mt-1" style="gap: 10px;">
                  <small style="opacity: 0.8;">Registered Organization</small>
                  <span v-if="!isLoading && organization.name" class="header-status--active">
                    <i class="fe fe-check-circle mr-1"></i> Verified
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -32px;">
        <div class="container pb-5">

          <div v-if="!isLoading && !organization.name" class="alert alert-warning">
            <i class="fe fe-alert-triangle mr-1"></i> This organization could not be found or is no longer registered.
          </div>

          <div class="row" v-if="organization.name">
            <!-- ── Summary Card ── -->
            <div class="col-lg-4 mb-4">
              <div class="card shadow h-100" style="border-radius: 14px; overflow: hidden; border: none;">
                <div style="height: 80px; background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);"></div>
                <div class="card-body text-center pt-0">
                  <div style="margin-top: -48px;" class="mb-3">
                    <div class="rounded-circle mx-auto d-flex align-items-center justify-content-center"
                      style="width: 96px; height: 96px; background: #fff; border: 4px solid #fff; box-shadow: 0 4px 16px rgba(0,0,0,0.12);">
                      <i class="fe fe-briefcase" style="font-size: 2.2rem; color: #2563eb;"></i>
                    </div>
                  </div>
                  <h5 class="font-weight-bold mb-1">{{ organization.name }}</h5>
                  <p class="text-muted mb-3" style="font-size: 0.82rem;">Verified Organization</p>
                  <span class="badge px-3 py-2" style="background: #d1fae5; color: #065f46; border-radius: 20px; font-size: 0.78rem;">
                    <i class="fe fe-check-circle mr-1"></i> Duly Registered
                  </span>
                  <div class="mt-4 pt-3" style="border-top: 1px solid #f1f5f9;">
                    <p class="text-muted mb-0" style="font-size: 0.72rem; text-transform: uppercase; letter-spacing: .05em;">
                      Enrollees Under this Organization
                    </p>
                    <h2 class="font-weight-bold mb-0" style="color: #1e3a5f;">{{ enrollees.length | numeral("0,0") }}</h2>
                  </div>
                </div>
              </div>
            </div>

            <!-- ── Enrollees List ── -->
            <div class="col-lg-8 mb-4">
              <div class="card shadow table-card">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-users" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Enrollees</h6>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table align-td-middle mb-0">
                      <thead>
                        <tr>
                          <th class="px-4">#</th>
                          <th>Name</th>
                          <th>ID</th>
                          <th>Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!enrollees.length">
                          <td colspan="4" class="text-center text-muted py-4">No enrollees on record yet.</td>
                        </tr>
                        <tr v-for="(enrollee, index) in enrollees" :key="enrollee.id">
                          <td class="px-4 text-muted">{{ index + 1 }}</td>
                          <td class="font-weight-bold">{{ enrollee.full_name }}</td>
                          <td>{{ enrollee.id_card_number }}</td>
                          <td>{{ enrollee.sector }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Navbar, Loading },

  data() {
    return {
      organization: {},
      enrollees: [],
      isLoading: false,
      fullPage: true,
    };
  },

  methods: {
    fetchOrganization() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/ministry-no-auth/${this.$route.params.id}`)
        .then((response) => {
          this.organization = response.data.data || {};
          this.enrollees = response.data.enrollees || [];
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
  },

  created() {
    this.fetchOrganization();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.header-icon-wrap {
  width: 52px; height: 52px; border-radius: 14px;
  background: rgba(255,255,255,.15);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.header-status--active {
  background: rgba(16,185,129,.2); color: #6ee7b7;
  padding: 2px 10px; border-radius: 20px; font-size: .74rem; font-weight: 600;
}
.form-card-header {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f, #2563eb);
}
.section-number {
  width: 22px; height: 22px; border-radius: 50%;
  background: rgba(255,255,255,.2); color: #fff;
  display: inline-flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.table-card { border-radius: 14px; overflow: hidden; border: none; }
.table thead th {
  background: #f8fafc; color: #64748b; font-weight: 600; font-size: .75rem;
  text-transform: uppercase; letter-spacing: .06em;
  border-bottom: 2px solid #e2e8f0; padding: 12px 16px;
}
.table tbody td { padding: 11px 16px; vertical-align: middle; border-color: #f1f5f9; font-size: .88rem; }
</style>
